export const OneTwoKLessons = [
  {
    lessonNumber: 1,
    lessonTitle: "Eating Meat",

    PreKoreanWord1: "I was trying to",
    KoreanWord1: "참다",
    KoreanWord1EngTranslation: "to endure, to hold back",
    PostKoreanWord1: "my hunger.",

    PreKoreanWord2: "But the",
    KoreanWord2: "크기",
    KoreanWord2EngTranslation: "size",
    PostKoreanWord2: "of this was too much to ignore.",

    PreKoreanWord3: "What a nice big piece of",
    KoreanWord3: "고기",
    KoreanWord3EngTranslation: "meat",
    PostKoreanWord3: "for me to enjoy!",

    PreKoreanWord4: "I wasn't going to",
    KoreanWord4: "남기다",
    KoreanWord4EngTranslation: "to leave (behind), save, reserve",
    PostKoreanWord4: "any to go to waste.",

    PreKoreanWord5: "A delicacy in the",
    KoreanWord5: "서양",
    KoreanWord5EngTranslation: "the West, Western countries",
    PostKoreanWord5: "and in the East.",

    PreKoreanWord6: "The",
    KoreanWord6: "주요",
    KoreanWord6EngTranslation: "main, major",
    PostKoreanWord6: "attraction of this meal.",

    PreKoreanWord7: "I'm really not",
    KoreanWord7: "지나치다",
    KoreanWord7EngTranslation: "to go too far, to be excessive; to pass by",
    PostKoreanWord7: "when I say this.",

    PreKoreanWord8: "If you can",
    KoreanWord8: "가져오다",
    KoreanWord8EngTranslation: "to bring",
    PostKoreanWord8: "the meat then I'm going to be happy.",

    PreKoreanWord9: "Even just the",
    KoreanWord9: "냄새",
    KoreanWord9EngTranslation: "smell, odor",
    PostKoreanWord9: "is going to get me excited.",

    PreKoreanWord10: "The meat is",
    KoreanWord10: "부드럽다",
    KoreanWord10EngTranslation: "soft, gentle",
    PostKoreanWord10: "to touch.",

    PreKoreanWord11: "I personally",
    KoreanWord11: "여기다",
    KoreanWord11EngTranslation: "to consider, regard",
    PostKoreanWord11: "this to be the best food.",

    PreKoreanWord12: "",
    KoreanWord12: "이",
    KoreanWord12EngTranslation: "this",
    PostKoreanWord12: "really is the best.",

    PreKoreanWord13: "I like to watch a",
    KoreanWord13: "공연",
    KoreanWord13EngTranslation: "performance, show",
    PostKoreanWord13: "and eat at the same time.",

    PreKoreanWord14: "Both",
    KoreanWord14: "남녀",
    KoreanWord14EngTranslation: "men and women",
    PostKoreanWord14: "can take delight in it.",

    PreKoreanWord15: "Just",
    KoreanWord15: "내놓다",
    KoreanWord15EngTranslation: "to put out, present, release",
    PostKoreanWord15: "on the table and let us be happy.",

    PreKoreanWord16: "Some people like to",
    KoreanWord16: "떼다",
    KoreanWord16EngTranslation: "to remove, detach",
    PostKoreanWord16: "the fatty parts, but not me.",

    PreKoreanWord17: "The whole thing was",
    KoreanWord17: "만들어지다",
    KoreanWord17EngTranslation: "to be made, be created",
    PostKoreanWord17: "to be eaten.",

    PreKoreanWord18: "I'll try to reduce the",
    KoreanWord18: "속도",
    KoreanWord18EngTranslation: "speed",
    PostKoreanWord18: "at which I eat.",

    PreKoreanWord19: "If I don't I might get",
    KoreanWord19: "심각하다",
    KoreanWord19EngTranslation: "serious, severe",
    PostKoreanWord19: "indigestion.",

    PreKoreanWord20: "The food has been",
    KoreanWord20: "준비",
    KoreanWord20EngTranslation: "preparation",
    PostKoreanWord20: "in the finest way.",

    PreKoreanWord21: "I'm sure it will",
    KoreanWord21: "계속되다",
    KoreanWord21EngTranslation: "to continue",
    PostKoreanWord21: "this way in the future.",

    PreKoreanWord22: "At least until the end of",
    KoreanWord22: "구월",
    KoreanWord22EngTranslation: "September",
    PostKoreanWord22: "when it starts to get a bit cooler.",

    PreKoreanWord23: "At that time of year we'll also get",
    KoreanWord23: "맑다",
    KoreanWord23EngTranslation: "clear, clean (weather, water)",
    PostKoreanWord23: "skies.",

    PreKoreanWord24: "All the young",
    KoreanWord24: "소년",
    KoreanWord24EngTranslation: "boy",
    PostKoreanWord24: "will come out to play.",

    PreKoreanWord25: "It'll be a change from all the bad",
    KoreanWord25: "소식",
    KoreanWord25EngTranslation: "news, information",
    PostKoreanWord25: "we keep getting.",

    PreKoreanWord26: "It's currently",
    KoreanWord26: "유월",
    KoreanWord26EngTranslation: "June",
    PostKoreanWord26: "so it's a bit too warm.",

    PreKoreanWord27: "I think it's the",
    KoreanWord27: "작용",
    KoreanWord27EngTranslation: "action, effect",
    PostKoreanWord27: "of global warming.",

    PreKoreanWord28: "Or maybe just my",
    KoreanWord28: "허리",
    KoreanWord28EngTranslation: "waist, lower back",
    PostKoreanWord28: "is too big.",

    PreKoreanWord29: "I'm sure down in the",
    KoreanWord29: "골",
    KoreanWord29EngTranslation: "valley; goal (sports)",
    PostKoreanWord29: "it's cooler.",

    PreKoreanWord30: "We need to regulate",
    KoreanWord30: "공업",
    KoreanWord30EngTranslation: "industry (manufacturing)",
    PostKoreanWord30: "if we're going to reduce pollution.",

    PreKoreanWord31: "There are three people in here and",
    KoreanWord31: "그중",
    KoreanWord31EngTranslation: "among them",
    PostKoreanWord31: "I'm the youngest.",

    PreKoreanWord32: "There is also a",
    KoreanWord32: "노인",
    KoreanWord32EngTranslation: "elderly person",
    PostKoreanWord32: "here so I should be polite.",

    PreKoreanWord33: "I need to get out there and",
    KoreanWord33: "벌다",
    KoreanWord33EngTranslation: "to earn (money)",
    PostKoreanWord33: "money to make life easier for us all.",

    PreKoreanWord34: "One day it might even",
    KoreanWord34: "살리다",
    KoreanWord34EngTranslation: "to save, keep alive, revive",
    PostKoreanWord34: "our lives.",

    PreKoreanWord35: "As I say this a",
    KoreanWord35: "새",
    KoreanWord35EngTranslation: "bird; new",
    PostKoreanWord35: "flies by.",

    PreKoreanWord36: "I can speak",
    KoreanWord36: "영어",
    KoreanWord36EngTranslation: "English (language)",
    PostKoreanWord36: "and I want to speak Korean too.",

    PreKoreanWord37: "My",
    KoreanWord37: "출신",
    KoreanWord37EngTranslation: "origin, background",
    PostKoreanWord37: "is abroad but I don't think it'll be a problem.",

    PreKoreanWord38: "I made the",
    KoreanWord38: "결정",
    KoreanWord38EngTranslation: "decision",
    PostKoreanWord38: "to do this a long time ago.",

    PreKoreanWord39: "I have a",
    KoreanWord39: "경향",
    KoreanWord39EngTranslation: "tendency, trend",
    PostKoreanWord39: "to think a lot about what I want to do.",

    PreKoreanWord40: "I even like to create a",
    KoreanWord40: "기록",
    KoreanWord40EngTranslation: "record, documentation",
    PostKoreanWord40: "to record it all.",

    PreKoreanWord41: "I do it",
    KoreanWord41: "나름",
    KoreanWord41EngTranslation: "in one's own way; depending on",
    PostKoreanWord41: "and I don't think twice.",

    PreKoreanWord42: "Thinking can help to",
    KoreanWord42: "대답하다",
    KoreanWord42EngTranslation: "to answer",
    PostKoreanWord42: "a lot of the questions I have.",

    PreKoreanWord43: "Yet",
    KoreanWord43: "반면",
    KoreanWord43EngTranslation: "on the other hand",
    PostKoreanWord43: "there's always more to think about.",

    PreKoreanWord44: "I'm thinking while",
    KoreanWord44: "썰다",
    KoreanWord44EngTranslation: "to slice, chop",
    PostKoreanWord44: "the meat on my plate.",

    PreKoreanWord45: "It seems like nothing is",
    KoreanWord45: "움직임",
    KoreanWord45EngTranslation: "movement",
    PostKoreanWord45: "as I focus on the food.",

    PreKoreanWord46: "I had an",
    KoreanWord46: "이미지",
    KoreanWord46EngTranslation: "image",
    PostKoreanWord46: "in my mind and reality didn't disappoint.",

    PreKoreanWord47: "Nothing is going to",
    KoreanWord47: "터지다",
    KoreanWord47EngTranslation: "to burst, explode",
    PostKoreanWord47: "my bubble this time.",

    PreKoreanWord48: "The",
    KoreanWord48: "특성",
    KoreanWord48EngTranslation: "characteristic, property",
    PostKoreanWord48: "are just what I like.",

    PreKoreanWord49: "I'll tell the",
    KoreanWord49: "교장",
    KoreanWord49EngTranslation: "school principal",
    PostKoreanWord49: "about this next time I see him.",

    PreKoreanWord50: "I'm getting warm, I'll",
    KoreanWord50: "벗다",
    KoreanWord50EngTranslation: "to take off (clothes, shoes), remove",
    PostKoreanWord50: "my coat.",
  },

  {
    lessonNumber: 2,
    lessonTitle: "A walk on the Mountain",

    PreKoreanWord1: "In the morning, I checked my",
    KoreanWord1: "업무",
    KoreanWord1EngTranslation: "work; task; duty",
    PostKoreanWord1: "list to see what I had to do.",

    PreKoreanWord2: "Students are taking the",
    KoreanWord2: "입시",
    KoreanWord2EngTranslation: "entrance exam",
    PostKoreanWord2: "today, so everywhere will be quiet.",

    PreKoreanWord3: "I decided to",
    KoreanWord3: "준비하다",
    KoreanWord3EngTranslation: "to prepare",
    PostKoreanWord3: "my hiking bag.",

    PreKoreanWord4: "A group of",
    KoreanWord4: "청소년",
    KoreanWord4EngTranslation: "teenagers; youths",
    PostKoreanWord4: "hikers asked if I could guide them.",

    PreKoreanWord5: "I agreed to",
    KoreanWord5: "돕다",
    KoreanWord5EngTranslation: "to help",
    PostKoreanWord5: "them.",

    PreKoreanWord6: "I said,",
    KoreanWord6: "응",
    KoreanWord6EngTranslation: "yeah; okay (casual)",
    PostKoreanWord6: "follow me.",

    PreKoreanWord7: "They wanted to",
    KoreanWord7: "이기다",
    KoreanWord7EngTranslation: "to win",
    PostKoreanWord7: "the race to the top.",

    PreKoreanWord8: "One boy tried to",
    KoreanWord8: "찾아보다",
    KoreanWord8EngTranslation: "to look for; to search",
    PostKoreanWord8: "the best route.",

    PreKoreanWord9: "We were all",
    KoreanWord9: "취하다",
    KoreanWord9EngTranslation: "to be intoxicated; captivated",
    PostKoreanWord9: "with excitement.",

    PreKoreanWord10: "I showed them how to safely",
    KoreanWord10: "다루다",
    KoreanWord10EngTranslation: "to handle; to deal with",
    PostKoreanWord10: "the terrain.",

    PreKoreanWord11: "The full moon had passed this",
    KoreanWord11: "달",
    KoreanWord11EngTranslation: "month; moon",
    PostKoreanWord11: "but the sky was still bright.",

    PreKoreanWord12: "I felt like the",
    KoreanWord12: "사장",
    KoreanWord12EngTranslation: "boss; president",
    PostKoreanWord12: "of a small hiking club.",

    PreKoreanWord13: "We joked that the weather in",
    KoreanWord13: "삼월",
    KoreanWord13EngTranslation: "March",
    PostKoreanWord13: "always surprises us.",

    PreKoreanWord14: "The kids got tired",
    KoreanWord14: "그렇지만",
    KoreanWord14EngTranslation: "but; however",
    PostKoreanWord14: "they wanted to keep going.",

    PreKoreanWord15: "The young hikers were listening to their",
    KoreanWord15: "선배",
    KoreanWord15EngTranslation: "senior; older peer",
    PostKoreanWord15: "for encouragement.",

    PreKoreanWord16: "We passed a small food",
    KoreanWord16: "업체",
    KoreanWord16EngTranslation: "business; company",
    PostKoreanWord16: "near the trail.",

    PreKoreanWord17: "A boy compared his",
    KoreanWord17: "키",
    KoreanWord17EngTranslation: "height",
    PostKoreanWord17: "with the height of a signpost.",

    PreKoreanWord18: "He tried to",
    KoreanWord18: "구하다",
    KoreanWord18EngTranslation: "to get; to obtain",
    PostKoreanWord18: "a hiking map, but couldn't find one.",

    PreKoreanWord19: "We joked that even the",
    KoreanWord19: "국회",
    KoreanWord19EngTranslation: "National Assembly; parliament",
    PostKoreanWord19: "couldn’t keep trails organised.",

    PreKoreanWord20: "I explained the path clearly",
    KoreanWord20: "그러므로",
    KoreanWord20EngTranslation: "therefore",
    PostKoreanWord20: "we wouldn’t get lost.",

    PreKoreanWord21: "Our plan didn’t",
    KoreanWord21: "포함하다",
    KoreanWord21EngTranslation: "to include",
    PostKoreanWord21: "any steep climbs today.",

    PreKoreanWord22: "One boy looked",
    KoreanWord22: "걱정",
    KoreanWord22EngTranslation: "worry; concern",
    PostKoreanWord22: "about it all.",

    PreKoreanWord23: "I'm",
    KoreanWord23: "결혼하다",
    KoreanWord23EngTranslation: "to marry",
    PostKoreanWord23: "and my wife wants me home.",

    PreKoreanWord24: "But",
    KoreanWord24: "만약",
    KoreanWord24EngTranslation: "if; in case",
    PostKoreanWord24: "anyone falls, I'm going to be in trouble.",

    PreKoreanWord25: "I helped him",
    KoreanWord25: "바르다",
    KoreanWord25EngTranslation: "to apply; to spread",
    PostKoreanWord25: "sunscreen on his face.",

    PreKoreanWord26: "As we walked, I thought about how fast",
    KoreanWord26: "세월",
    KoreanWord26EngTranslation: "time; passing years",
    PostKoreanWord26: "passes.",

    PreKoreanWord27: "We all stopped to catch our",
    KoreanWord27: "숨",
    KoreanWord27EngTranslation: "breath",
    PostKoreanWord27: "at a lookout point.",

    PreKoreanWord28: "There was a small cultural",
    KoreanWord28: "행사",
    KoreanWord28EngTranslation: "event",
    PostKoreanWord28: "happening nearby.",

    PreKoreanWord29: "We all began to",
    KoreanWord29: "깨닫다",
    KoreanWord29EngTranslation: "to realize",
    PostKoreanWord29: "how beautiful nature is.",

    PreKoreanWord30: "One boy said he missed his",
    KoreanWord30: "누나",
    KoreanWord30EngTranslation: "older sister (male speaker)",
    PostKoreanWord30: "and wanted to bring her next time.",

    PreKoreanWord31: "Some say a mountain",
    KoreanWord31: "신",
    KoreanWord31EngTranslation: "god; spirit",
    PostKoreanWord31: "lives here.",

    PreKoreanWord32: "There was a statue of a",
    KoreanWord32: "왕",
    KoreanWord32EngTranslation: "king",
    PostKoreanWord32: "guarding the forest.",

    PreKoreanWord33: "The higher we climbed, the view",
    KoreanWord33: "점점",
    KoreanWord33EngTranslation: "gradually; increasingly",
    PostKoreanWord33: "changed.",

    PreKoreanWord34: "The kids asked many",
    KoreanWord34: "질문",
    KoreanWord34EngTranslation: "questions",
    PostKoreanWord34: "about the mountain.",

    PreKoreanWord35: "I told them they were on a",
    KoreanWord35: "특별",
    KoreanWord35EngTranslation: "special",
    PostKoreanWord35: "adventure today.",

    PreKoreanWord36: "With good",
    KoreanWord36: "판단",
    KoreanWord36EngTranslation: "judgment",
    PostKoreanWord36: "we chose the safest path.",

    PreKoreanWord37: "We tried to",
    KoreanWord37: "해결하다",
    KoreanWord37EngTranslation: "to solve",
    PostKoreanWord37: "the problem of finding a shady spot.",

    PreKoreanWord38: "From there, the",
    KoreanWord38: "거리",
    KoreanWord38EngTranslation: "distance",
    PostKoreanWord38: "to the peak looked short.",

    PreKoreanWord39: "We promised to",
    KoreanWord39: "계속하다",
    KoreanWord39EngTranslation: "to continue",
    PostKoreanWord39: "slowly and safely.",

    PreKoreanWord40: "Suddenly, the wind",
    KoreanWord40: "그치다",
    KoreanWord40EngTranslation: "to stop; to cease",
    PostKoreanWord40: "and it was calm.",

    PreKoreanWord41: "A café was located",
    KoreanWord41: "근처",
    KoreanWord41EngTranslation: "nearby",
    PostKoreanWord41: "the summit.",

    PreKoreanWord42: "The kids were",
    KoreanWord42: "너무나",
    KoreanWord42EngTranslation: "so; very",
    PostKoreanWord42: "happy to rest there.",

    PreKoreanWord43: "They wanted to",
    KoreanWord43: "높이다",
    KoreanWord43EngTranslation: "to raise; to increase",
    PostKoreanWord43: "their energy with snacks.",

    PreKoreanWord44: "One boy made a",
    KoreanWord44: "부정",
    KoreanWord44EngTranslation: "negative; disapproving",
    PostKoreanWord44: "face after trying the tea.",

    PreKoreanWord45: "I asked about the",
    KoreanWord45: "사정",
    KoreanWord45EngTranslation: "circumstances; situation",
    PostKoreanWord45: "and he said he hated tea.",

    PreKoreanWord46: "“What",
    KoreanWord46: "도대체",
    KoreanWord46EngTranslation: "on earth; what the heck",
    PostKoreanWord46: "were you expecting?” I laughed.",

    PreKoreanWord47: "Another boy had",
    KoreanWord47: "막",
    KoreanWord47EngTranslation: "just; just now",
    PostKoreanWord47: "spilled his drink everywhere.",

    PreKoreanWord48: "He apologized and said his",
    KoreanWord48: "부모님",
    KoreanWord48EngTranslation: "parents",
    PostKoreanWord48: "gets angry when he does that.",

    PreKoreanWord49: "I saw local products ready for",
    KoreanWord49: "수출",
    KoreanWord49EngTranslation: "export",
    PostKoreanWord49: "to America.",

    PreKoreanWord50: "The owner seemed to",
    KoreanWord50: "계시다",
    KoreanWord50EngTranslation: "to stay; to be (honorific)",
    PostKoreanWord50: "there all day, smiling warmly at everyone.",
  },

  {
    lessonNumber: 3,
    lessonTitle: "A Long Business Trip Across the Country",

    PreKoreanWord1: "I woke up knowing",
    KoreanWord1: "그",
    KoreanWord1EngTranslation: "that; he, him, himself",
    PostKoreanWord1: "meeting would determine our future.",

    PreKoreanWord2: "I had to",
    KoreanWord2: "자르다",
    KoreanWord2EngTranslation: "cut",
    PostKoreanWord2: "my presentation notes down to a shorter version.",

    PreKoreanWord3: "My colleague offered to",
    KoreanWord3: "데리다",
    KoreanWord3EngTranslation: "take (someone somewhere)",
    PostKoreanWord3: "me to the airport.",

    PreKoreanWord4: "At the departure gate I saw a one",
    KoreanWord4: "마리",
    KoreanWord4EngTranslation: "counter for counting animals (classifier)",
    PostKoreanWord4: "service dog.",

    PreKoreanWord5: "The airport was",
    KoreanWord5: "무척",
    KoreanWord5EngTranslation: "very, extremely",
    PostKoreanWord5: "busy for a weekday morning.",

    PreKoreanWord6: "I checked the",
    KoreanWord6: "비용",
    KoreanWord6EngTranslation: "cost",
    PostKoreanWord6: "of my hotel again.",

    PreKoreanWord7: "Soon it was time to board the",
    KoreanWord7: "비행기",
    KoreanWord7EngTranslation: "airplane",
    PostKoreanWord7: "and start the journey.",

    PreKoreanWord8: "It felt",
    KoreanWord8: "옳다",
    KoreanWord8EngTranslation: "right",
    PostKoreanWord8: "to finally be traveling.",

    PreKoreanWord9: "I remembered I had",
    KoreanWord9: "원래",
    KoreanWord9EngTranslation: "originally",
    PostKoreanWord9: "planned to visit this city years ago.",

    PreKoreanWord10: "When I landed, I had to",
    KoreanWord10: "처리",
    KoreanWord10EngTranslation: "handle, process",
    PostKoreanWord10: "several emails before going to the hotel.",

    PreKoreanWord11: "The company had sent me to their",
    KoreanWord11: "최초",
    KoreanWord11EngTranslation: "first, original",
    PostKoreanWord11: "office which was built decades ago.",

    PreKoreanWord12: "The lobby had an unusual",
    KoreanWord12: "꼴",
    KoreanWord12EngTranslation: "shape, appearance",
    PostKoreanWord12: "that made it look like a museum.",

    PreKoreanWord13: "Kids were in a small",
    KoreanWord13: "놀이",
    KoreanWord13EngTranslation: "play",
    PostKoreanWord13: "area near reception.",

    PreKoreanWord14: "I grabbed a coffee that was too",
    KoreanWord14: "뜨겁다",
    KoreanWord14EngTranslation: "hot",
    PostKoreanWord14: "to drink right away.",

    PreKoreanWord15: "The long",
    KoreanWord15: "뿌리",
    KoreanWord15EngTranslation: "roots",
    PostKoreanWord15: "of a tree symbolize the company’s history.",

    PreKoreanWord16: "The receptionist told me most of their",
    KoreanWord16: "수입",
    KoreanWord16EngTranslation: "income",
    PostKoreanWord16: "now came from overseas.",

    PreKoreanWord17: "I saw my name on the computer for a few",
    KoreanWord17: "초",
    KoreanWord17EngTranslation: "seconds",
    PostKoreanWord17: "before it updated.",

    PreKoreanWord18: "I was tired",
    KoreanWord18: "그리하여",
    KoreanWord18EngTranslation: "and so, therefore",
    PostKoreanWord18: "I decided to rest before the meetings.",

    PreKoreanWord19: "It was still",
    KoreanWord19: "낮",
    KoreanWord19EngTranslation: "day, daytime",
    PostKoreanWord19: "so I stepped outside to explore.",

    PreKoreanWord20: "I had arrived",
    KoreanWord20: "일찍",
    KoreanWord20EngTranslation: "early",
    PostKoreanWord20: "so I had time to look around.",

    PreKoreanWord21: "Inside the office lobby, every",
    KoreanWord21: "직원",
    KoreanWord21EngTranslation: "employee",
    PostKoreanWord21: "seemed friendly yet focused.",

    PreKoreanWord22: "A photographer came to",
    KoreanWord22: "찍다",
    KoreanWord22EngTranslation: "take a picture",
    PostKoreanWord22: "our team for the company newsletter.",

    PreKoreanWord23: "My suitcase felt surprisingly",
    KoreanWord23: "가볍다",
    KoreanWord23EngTranslation: "light",
    PostKoreanWord23: "after the long trip.",

    PreKoreanWord24: "The",
    KoreanWord24: "내부",
    KoreanWord24EngTranslation: "interior",
    PostKoreanWord24: "of the conference room looked modern and stylish.",

    PreKoreanWord25: "There was",
    KoreanWord25: "다소",
    KoreanWord25EngTranslation: "somewhat, rather",
    PostKoreanWord25: "a lot of noise from the renovation work.",

    PreKoreanWord26: "I met my",
    KoreanWord26: "상대",
    KoreanWord26EngTranslation: "counterpart, partner; deal with; opponent",
    PostKoreanWord26: "who I would be negotiating with.",

    PreKoreanWord27: "Our first meeting was scheduled for",
    KoreanWord27: "오전",
    KoreanWord27EngTranslation: "morning",
    PostKoreanWord27: "the next day.",

    PreKoreanWord28: "One member had very sensitive",
    KoreanWord28: "피부",
    KoreanWord28EngTranslation: "skin",
    PostKoreanWord28: "and kept adjusting the air conditioner.",

    PreKoreanWord29: "We walked to a small",
    KoreanWord29: "가게",
    KoreanWord29EngTranslation: "shop",
    PostKoreanWord29: "near the hotel to buy snacks.",

    PreKoreanWord30: "The store shelves were",
    KoreanWord30: "가득",
    KoreanWord30EngTranslation: "full",
    PostKoreanWord30: "of unfamiliar brands.",

    PreKoreanWord31: "It was",
    KoreanWord31: "그저",
    KoreanWord31EngTranslation: "just, simply",
    PostKoreanWord31: "a quiet evening in a new city.",

    PreKoreanWord32: "I thought the atmosphere was calm",
    KoreanWord32: "도",
    KoreanWord32EngTranslation: "also, too",
    PostKoreanWord32: "civilized.",

    PreKoreanWord33: "Back in my room I stared at the",
    KoreanWord33: "벽",
    KoreanWord33EngTranslation: "wall",
    PostKoreanWord33: "thinking about tomorrow.",

    PreKoreanWord34: "The founder had been a",
    KoreanWord34: "장군",
    KoreanWord34EngTranslation: "general, admiral",
    PostKoreanWord34: "before starting his business.",

    PreKoreanWord35: "Success came from strong",
    KoreanWord35: "무역",
    KoreanWord35EngTranslation: "trade",
    PostKoreanWord35: "relationships abroad.",

    PreKoreanWord36: "Still, the project posed a heavy",
    KoreanWord36: "부담",
    KoreanWord36EngTranslation: "burden",
    PostKoreanWord36: "on everyone involved.",

    PreKoreanWord37: "We agreed to meet again after our",
    KoreanWord37: "약속",
    KoreanWord37EngTranslation: "appointment, promise",
    PostKoreanWord37: "with the marketing director.",

    PreKoreanWord38: "We greeted each other with warm",
    KoreanWord38: "인사",
    KoreanWord38EngTranslation: "greeting",
    PostKoreanWord38: "before the meeting began.",

    PreKoreanWord39: "I stood in",
    KoreanWord39: "줄",
    KoreanWord39EngTranslation: "line, row; cord, rope",
    PostKoreanWord39: "waiting to get in.",

    PreKoreanWord40: "People listened closely and",
    KoreanWord40: "쳐다보다",
    KoreanWord40EngTranslation: "to look up at, gaze at",
    PostKoreanWord40: "the charts behind me.",

    PreKoreanWord41: "Our proposal was",
    KoreanWord41: "충분히",
    KoreanWord41EngTranslation: "enough, sufficiently",
    PostKoreanWord41: "detailed to answer all their questions.",

    PreKoreanWord42: "It didn't feel like me",
    KoreanWord42: "대",
    KoreanWord42EngTranslation: "versus; big",
    PostKoreanWord42: "them at all.",

    PreKoreanWord43: "I had a clear",
    KoreanWord43: "신체",
    KoreanWord43EngTranslation: "body, bodily, physical",
    PostKoreanWord43: "check so felt fit.",

    PreKoreanWord44: "Everyone was surprised by the increased",
    KoreanWord44: "에너지",
    KoreanWord44EngTranslation: "energy",
    PostKoreanWord44: "costs this year.",

    PreKoreanWord45: "A senior",
    KoreanWord45: "위원",
    KoreanWord45EngTranslation: "committee member",
    PostKoreanWord45: "joined us through video conference.",

    PreKoreanWord46: "Afterward we took time to",
    KoreanWord46: "정리하다",
    KoreanWord46EngTranslation: "organize",
    PostKoreanWord46: "our notes before dinner.",

    PreKoreanWord47: "I called my family to check on the",
    KoreanWord47: "집안",
    KoreanWord47EngTranslation: "household",
    PostKoreanWord47: "while waiting for my meal.",

    PreKoreanWord48: "I know I've got the",
    KoreanWord48: "배경",
    KoreanWord48EngTranslation: "background; setting",
    PostKoreanWord48: "knowledge to get it right.",

    PreKoreanWord49: "Then we ate a spicy dish that nearly",
    KoreanWord49: "죽이다",
    KoreanWord49EngTranslation: "to kill",
    PostKoreanWord49: "me with its heat.",

    PreKoreanWord50: "The trip felt surprisingly",
    KoreanWord50: "단순하다",
    KoreanWord50EngTranslation: "simple",
    PostKoreanWord50: "once everything was finally completed.",
  },
];
